module.exports = {"id":"50955","name":"Johan Cavalli","rating":"72","photo":"./data/images/photos/4/50955.png","club":{"name":"AC Ajaccio","logo":"./data/images/clubs/ACAjaccio.png"},"positions":["MOC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JohanCavalli0.json
// module id = 2063
// module chunks = 0